import { DateTime } from "luxon";
import { LocalStorageKeys } from "../types/LocalStorageKeys";
import { PendingPremiumOrder } from "../types/PendingPremiumOrder";

/**
 * Retrieves the pending premium order from localStorage if it exists and is not expired.
 * Orders older than 10 minutes are considered expired and will return null.
 *
 * @returns The full pending order object if valid and not expired, otherwise null
 */
export const getPendingPremiumOrder = (): PendingPremiumOrder | null => {
  const stored = localStorage.getItem(LocalStorageKeys.PENDING_PREMIUM_ORDER);

  if (!stored) {
    return null;
  }

  try {
    const pendingOrder: PendingPremiumOrder = JSON.parse(stored);

    // Parse the stored UTC timestamp
    const orderTime = DateTime.fromISO(pendingOrder.timestamp, { zone: "utc" });

    // Get current UTC time
    const now = DateTime.utc();

    // Calculate the difference in minutes
    const minutesElapsed = now.diff(orderTime, "minutes").minutes;

    // If more than 10 minutes have passed, the order is expired
    if (minutesElapsed > 10) {
      localStorage.removeItem(LocalStorageKeys.PENDING_PREMIUM_ORDER);
      return null;
    }

    // Order is still valid, return the full object
    return pendingOrder;
  } catch (error) {
    localStorage.removeItem(LocalStorageKeys.PENDING_PREMIUM_ORDER);
    return null;
  }
};

export const clearPendingPremiumOrder = (): void => {
  localStorage.removeItem(LocalStorageKeys.PENDING_PREMIUM_ORDER);
};